import Vue from 'vue'
import VueResource from 'vue-resource'
import VueI18n from 'vue-i18n'
import LangEn from '../../common/lang/en'
import LangZhCN from '../../common/lang/zh_CN'
import LangZhTW from '../../common/lang/zh_TW'
import LangRu from '../../common/lang/ru'
import VueRouter from 'vue-router'
import Login from 'components/login/login.vue'
import Country from 'components/country/country.vue'
import ResetPwd from 'components/personalCenter/resetPwd.vue'
import UpdateSuccess from 'components/personalCenter/updateSuccess.vue'
Vue.use(VueResource)
Vue.use(VueRouter)
Vue.use(VueI18n)
import App from './index.vue'
import Config from 'common/script/config.js'
import 'common/script/getRem.js'
import 'common/stylus/index.styl'
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
Vue.use(ElementUI)
Vue.http.options.emulateJSON = true
Vue.http.interceptors.push((request, next) => {
    // 请求发送前的处理逻辑
  Vue.http.headers.common[Config.HTTP_HEADER_KEY.APP_KEY] = Config.APP_KEY
  // Vue.http.headers.common[Config.HTTP_HEADER_KEY.UDID] = navigator.appVersion
  Vue.http.headers.common[Config.HTTP_HEADER_KEY.CHANNEL] = Config.getChannel()
  Vue.http.headers.common[Config.HTTP_HEADER_KEY.USERID] = Config.cookieGet(Config.COOKIE_KEY.U_ID)
  Vue.http.headers.common[Config.HTTP_HEADER_KEY.TOKEN] = Config.cookieGet(Config.COOKIE_KEY.TOKEN)
  next((response) => {
        // ...
        // 请求发送后的处理逻辑
        // ...
        // 根据请求的状态，response参数会返回给successCallback或errorCallback
    return response
  })
})

const i18n = new VueI18n({
  locale: 'en', // 语言标识
  messages: {
    'en': LangEn,
    'zh-CN': LangZhCN,
    'zh-TW': LangZhTW,
    'ru_RU': LangRu
  }
})

// 检测浏览器语言
var currentLang = Config.lang()

setI18nLanguage(currentLang)

function setI18nLanguage (lang) {
  i18n.locale = lang
  document.querySelector('html').setAttribute('lang', lang) // 根元素增加lang属性
  return lang
}

Vue.directive('title', {
  inserted: function (el, binding) {
    document.title = el.dataset.title
  },
  update: function (el, binding) {
    document.title = el.dataset.title
  }
})

const routes = [
  { path: '/', redirect: '/login' },
  { path: '/login', component: Login },
  { path: '/country', component: Country },
  { path: '/resetPwd/:type', component: ResetPwd },
  { path: '/updateSuccess/:type', component: UpdateSuccess }
]

const router = new VueRouter({
  routes
})

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  i18n,
  template: '<App/>',
  components: { App }
})



// WEBPACK FOOTER //
// ./src/module/index/index.js